import { render, staticRenderFns } from "./videoControl.vue?vue&type=template&id=131aace2&scoped=true"
import script from "./videoControl.vue?vue&type=script&lang=js"
export * from "./videoControl.vue?vue&type=script&lang=js"
import style0 from "./videoControl.vue?vue&type=style&index=0&id=131aace2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131aace2",
  null
  
)

export default component.exports